module.exports = __webpack_public_path__ + "static/img/illustratepic_02.1740ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-CN/illustratepic_02.png
// module id = da9i
// module chunks = 1